import React from "react";
import {Input} from "../../Utilits/Fields";
import {Field, reduxForm} from "redux-form";
import loup from "../../img/users/loup.png"

const UsersForm = (props) => {
    return(
        <form onSubmit={props.handleSubmit} className='users__search-form'>
            <Field component={Input} name='term' type="text" placeholders="Имя пользователя"/>
            <button><img src={loup} alt=""/></button>
        </form>
    )
};
export default reduxForm({form: "search"})(UsersForm);